// extracted by mini-css-extract-plugin
export default {"content":"AF","wrapper":"BF","gif":"CF","textContent":"EF","gifContainer":"FF","proteinGif":"GF","counter_img":"HF","usage-container":"IF","usage-list":"JF","checklist":"KF","counter_title":"LF","counter_wrapper":"MF","active":"NF","usage-counter":"OF","line":"PF"};
    if(module.hot) {
      // 1715276856654
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  